import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Profile from './Profile';
import UploadImage from './UploadImage';
import ChangePassword from './ChangePassword';
import { IRootState } from '../../interfaces';
import { connect } from 'react-redux';
import {
  IDashboardState,
  IDashboardProps,
} from '../../interfaces/dashboard.interface';

class Dashboard extends Component<IDashboardProps, IDashboardState> {
  constructor(props: IDashboardProps) {
    super(props);
    this.state = {
      show: false,
      defaultActiveKey: 'topics',
    };
  }

  componentDidMount = () => {
    const { location } = this.props;
    const { state } = this;
    this.setState({
      defaultActiveKey:
        state && state.defaultActiveKey ? state.defaultActiveKey : 'my-account',
    });
    const header: HTMLElement | null = document.getElementById('mainHeader');
    if (header) {
      header.classList.add('inner-head');
    }
  };

  coursemodalClose = () => {
    this.setState({ show: false });
  };
  coursemodalShow = () => {
    this.setState({ show: true });
  };
  onChangeTab = (activeKey: string) => {
    this.setState({
      defaultActiveKey: activeKey,
    });
  };
  render() {
    const { defaultActiveKey } = this.state;

    return (
      <React.Fragment>
        {/* ========LOKEM PROFILE START+========= */}
        <div id="right-container">
        <UploadImage />
        <Profile />
        <ChangePassword />
        {/* ======LOKEM PROFILE END======= */}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  profileReducer: state.profileReducer,
});

export default connect(mapStateToProps)(Dashboard);
